import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ILocation } from '@nimbus-global/features/shared/services/api/i-location.models';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';

@Component({
  standalone: false,
  selector: 'nimbus-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationListComponent),
      multi: true,
    },
  ],
})
export class LocationListComponent implements ControlValueAccessor {
  @Input() public locations: ILocation[];
  @Input() public allowToPreSelectLocation: boolean = true;
  @Input() public position: string = 'horizontal'; // 'horizontal' || 'vertical'
  @Output() public initialLocation: EventEmitter<ILocation> = new EventEmitter<ILocation>();

  private onChange: (location: ILocation) => void;
  private onTouched: () => void;

  public readonly TranslationKeys = TranslationKeys;
  public readonly ICONS = ICONS;
  public readonly selectedLocation$: BehaviorSubject<ILocation> = new BehaviorSubject(null);
  public readonly isDisabled$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public writeValue(selectedLocation: ILocation): void {
    this.selectedLocation$.next(selectedLocation);
    this.initialLocation.emit(selectedLocation);
  }

  public registerOnChange(fn: (location: ILocation) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled$.next(isDisabled);
  }

  public selectLocation(location: ILocation): void {
    this.selectedLocation$.next(location);
    this.allowToPreSelectLocation = true;

    this.onChange && this.onChange(location);
    this.onTouched && this.onTouched();
  }
}
